import { testingRoutes as testing } from './testing';

// we can added more routes to this arr in future
export const routes = [testing];
